export default __webpack_public_path__ + "ae1846df9e3298d3c61c14428165e81b.webp";